var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLotti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#EFF0F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.8C15.54 9.8 14.42 11.76 13.37 13.65C12.53 15.26 11.69 16.8 10.5 16.8C10.08 16.8 9.8 17.08 9.8 17.5C9.8 17.92 10.08 18.2 10.5 18.2C12.46 18.2 13.58 16.24 14.63 14.35C15.47 12.74 16.31 11.2 17.5 11.2C17.92 11.2 18.2 10.92 18.2 10.5C18.2 10.08 17.92 9.8 17.5 9.8ZM18.9 7H9.1C7.91 7 7 7.91 7 9.1V18.9C7 20.09 7.91 21 9.1 21H18.9C20.09 21 21 20.09 21 18.9V9.1C21 7.91 20.09 7 18.9 7ZM19.6 18.9C19.6 19.32 19.32 19.6 18.9 19.6H9.1C8.68 19.6 8.4 19.32 8.4 18.9V9.1C8.4 8.68 8.68 8.4 9.1 8.4H18.9C19.32 8.4 19.6 8.68 19.6 9.1V18.9Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotti);
export default __webpack_public_path__ + "static/media/lotti.2e0fff70.svg";
export { ForwardRef as ReactComponent };